import { render, staticRenderFns } from "./Security.vue?vue&type=template&id=43cf3bf6&scoped=true"
import script from "./Security.vue?vue&type=script&lang=js"
export * from "./Security.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43cf3bf6",
  null
  
)

export default component.exports